export function showTab(tabName) {
      // Reset Tabs
      document.querySelectorAll('.auth-tab').forEach(t => t.classList.remove('active'));
      document.getElementById('tab-' + tabName).classList.add('active');
      // Reset Panels
      document.querySelectorAll('.form-panel').forEach(p => p.classList.remove('active'));
      document.getElementById('panel-' + tabName).classList.add('active');
};

// ---------- MESSAGES ----------
export function showMessage(text, type = 'error') {
  const msg = document.getElementById('message');
  if (!msg) return;
  msg.innerHTML = `<div class="msg ${type}">${text}</div>`;
}

export function clearMessage() {
  const msg = document.getElementById('message');
  if (!msg) return;
  msg.innerHTML = '';
}
